import React from 'react'

import { Button, InputAdornment, TextField } from '@material-ui/core'
import { isEmpty, trim } from 'lodash'
import PropTypes from 'prop-types'

import './index.scss'

const PROTOCOL = {
  unsecured: 'http://',
  secure: 'https://',
}

const linkRegex = /^https?:\/\/[w.]{0,4}[^.]+\.[a-zA-Z]{1,}\/?.+$/m

export const validateLink = (value) => {
  const isBlank = isEmpty(value) || value === PROTOCOL.unsecured || value === PROTOCOL.secure
  const isLink = linkRegex.test(value)
  return isBlank || isLink
}
const secureProtocolRegExp = new RegExp(`^https://`, 'm')
const unsecuredProtocolRegExp = new RegExp(`^http://`, 'm')
const protocolRegExp = new RegExp(`^https?://`, 'm')
const getProtocol = (url) => {
  if (secureProtocolRegExp.test(url)) {
    return PROTOCOL.secure
  }
  if (unsecuredProtocolRegExp.test(url)) {
    return PROTOCOL.unsecured
  }
}
const getUrlWithoutProtocol = (url) => url.replace(protocolRegExp, '')

export default class LinkField extends React.Component {
  static propTypes = {
    url: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
  }
  static unsecuredProps = {
    url: '',
  }
  btnRef = React.createRef()
  state = {
    protocol: PROTOCOL.secure,
    urlWithoutProtocol: '',
    open: false,
  }
  componentDidMount() {
    this.stripProtocol(this.props.url)
  }
  componentDidUpdate(prevProps, prevState) {
    const urlWithoutProtocolHasChanged = prevState.urlWithoutProtocol !== this.state.urlWithoutProtocol
    const protocolHasChanged = prevState.protocol !== this.state.protocol
    if (urlWithoutProtocolHasChanged || protocolHasChanged) {
      this.update()
    }
  }
  update() {
    const url = isEmpty(this.state.urlWithoutProtocol) ? '' : encodeURI(decodeURIComponent(this.getFullUrl()))

    const isValid = validateLink(this.getFullUrl())
    this.props.onChange(url, isValid)
  }
  getFullUrl() {
    return `${this.state.protocol}${this.state.urlWithoutProtocol}`
  }
  stripProtocol(url) {
    const trimUrl = trim(url)
    const protocol = getProtocol(trimUrl) || this.state.protocol
    const urlWithoutProtocol = getUrlWithoutProtocol(trimUrl)
    this.setState({
      protocol,
      urlWithoutProtocol,
    })
  }
  render() {
    const isValid = validateLink(this.getFullUrl())
    return (
      <div className="link-field-comp">
        <TextField
          label="Link"
          variant="outlined"
          error={!isValid}
          fullWidth
          value={this.state.urlWithoutProtocol}
          placeholder={this.props.placeholder}
          onChange={(e) => this.stripProtocol(e.target.value)}
          onBlur={() => this.props.onSubmit()}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              this.props.onSubmit()
            }
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment>
                <Button
                  ref={this.btnRef}
                  variant="outlined"
                  size="small"
                  onClick={() => {
                    const newProto = [PROTOCOL.secure, PROTOCOL.unsecured].find(
                      (protocol) => protocol !== this.state.protocol,
                    )
                    this.setState({
                      protocol: newProto,
                    })
                  }}
                >
                  {this.state.protocol}
                </Button>
              </InputAdornment>
            ),
          }}
        />
      </div>
    )
  }
}
